import { render, staticRenderFns } from "./PaymentView.vue?vue&type=template&id=8271785e&scoped=true"
import script from "./PaymentView.vue?vue&type=script&lang=js"
export * from "./PaymentView.vue?vue&type=script&lang=js"
import style0 from "./PaymentView.vue?vue&type=style&index=0&id=8271785e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8271785e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8271785e')) {
      api.createRecord('8271785e', component.options)
    } else {
      api.reload('8271785e', component.options)
    }
    module.hot.accept("./PaymentView.vue?vue&type=template&id=8271785e&scoped=true", function () {
      api.rerender('8271785e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/reinbursement/components/details/PaymentView.vue"
export default component.exports